import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useOrderContext } from "../../../../contexts/OrderContext";
import { SavedProgressReducerActionTypes } from "../../../../contexts/reducers/savedProgressReducer";
import { IDeliveryItem } from "../../../../models/deliveryItem";
import EditableDeliveryItems from "../../../newOrder/components/itemLists/deliveryItems/EditableDeliveryItems";
import BaseContent from "../BaseContent";

interface DeliveryItemsScreenProps {}

const DeliveryItemsScreen = (props: DeliveryItemsScreenProps) => {
  const { t } = useTranslation();
  const { savedProgress, dispatchSavedProgress } = useOrderContext();

  const [deliveryItems, setDeliveryItems] = useState<IDeliveryItem[]>([]);

  const loadSavedProgress = () => {
    if (!savedProgress || !savedProgress.deliveryItems) return;

    setDeliveryItems(savedProgress.deliveryItems);
  };

  const saveProgress = () => {
    dispatchSavedProgress({
      type: SavedProgressReducerActionTypes.SET_PROP,
      property: "deliveryItems",
      value: deliveryItems,
    });
  };

  useEffect(() => {
    loadSavedProgress();
  }, []);

  return (
    <BaseContent
      screenName={"outboundDeliveryItemsScreen"}
      disableNext={deliveryItems.length === 0}
      proceedButtonText={t("proceedTimes")}
      saveProgress={saveProgress}
    >
      <EditableDeliveryItems
        deliveryItems={deliveryItems}
        setDeliveryItems={setDeliveryItems}
      />
    </BaseContent>
  );
};
export default DeliveryItemsScreen;
